import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/.redwood/functions/postmark')({
  loader: () => {
    throw redirect({ to: '/webhooks/postmark', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
